/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SubscriptionRegion { 
    /**
     * Long form of subscription region
     */
    long?: string;
    /**
     * Short form of subscription region
     */
    short?: string;
}

